import { motion } from "framer-motion";
import ProjectCon from "./ProjectCon";
import CodesipImg from "../static/images/codesip.jpeg";
import BFIImage from "../static/images/builtforimpact.png";
import DraftileImage from "../static/images/draftile.png";
import GlassBallImage from "../static/images/glassBall.jpeg";
import ClotickImage from "../static/images/clotick.jpeg";
import filesImage from "../static/images/files.png";
import AITutorImage from "../static/images/aitutorfinal.png";
import AITutorVideo from "../static/videos/aitutor.mov";
import { useState } from "react";

const Projects = ({ flipTransition, setProject, pFlag }) => {

    // const [ clickPopProject, setClickPopProject ] = useState();

    var projectData = [
        {
            "image": AITutorImage,
            "video": AITutorVideo, 
            "name": "AI Tutor",
            "desc": "Want to learn AI and ML but don't know where to start? AI Tutor can provide you with personalized learning plan with best resources.",
            "technology": ["MongoDB", "Expressjs", "Reactjs", "Nodejs"],
            "links": {
                "link": null,
                "doc": null,
                "github": "https://github.com/Darshan-SD/capstone.git"
            }
        },
        {
            "image": CodesipImg,
            // "video": null,
            "name": "Codesip",
            "desc": "It is a platform where you ask your imagination of web design and it will generate code and live preview for you.",
            "technology": ["MongoDB", "Expressjs", "Reactjs", "Nodejs"],
            "links": {
                "link": "https://codesip.netlify.app",
                "doc": null,
                "github": null
            }
        },
        {
            "image": BFIImage,
            // "video": null,
            "name": "Built For Impact",
            "desc": "A platform for the students and by the students to help them in their career. It is a platform where students can find resources, projects, and events to enhance their skills.",
            "technology": ["Wordpress"],
            "links": {
                "link": "https://app.builtforimpact.ca",
                "doc": null,
                "github": null
            }
        },
        {
            "image": DraftileImage,
            // "video": null,
            "name": "Draftile",
            "desc": "This is where you can find wallpapers for your desktop and mobile. It is a library of my imaginations.",
            "technology": ["MongoDB", "Expressjs", "Reactjs", "Nodejs", "Bootstrap"],
            "links": {
                "link": "https://dwallpapers.netlify.app",
                "doc": null,
                "github": null
            }
        },
    ];

    var frontendProjects = [
        {
            "image": filesImage,
            "video": null, 
            "name": "Files",
            "technology": ["React"],
            "links": {
                "link": "https://dfiles.netlify.app/",
                "doc": null,
                "github": "https://github.com/Darshan-SD/files.git"
            }
        },
        {
            "image": GlassBallImage,
            "video": null, 
            "name": "Glass Ball",
            "technology": ["HTML", "CSS", "JavaScript"],
            "links": {
                "link": "https://darshan-sd.github.io/droplet-photo-library/",
                "doc": null,
                "github": "https://github.com/Darshan-SD/droplet-photo-library.git"
            }
        },
        {
            "image": ClotickImage,
            "video": null, 
            "name": "Clotick",
            "technology": ["HTML", "CSS", "JavaScript"],
            "links": {
                "link": "https://darshan-sd.github.io/clock/",
                "doc": null,
                "github": "https://github.com/Darshan-SD/clock.git"
            }
        },
    ];

    return (
        <motion.div
            variants={flipTransition}
            initial="hidden"
            animate="show"
        >
            <h2 className="heading">Work</h2>
            <ProjectCon projects={projectData} setP={setProject} pFlag={pFlag} showPopupFlag={true} />

            <h2 className="heading">Getting Creative</h2>
            <ProjectCon projects={frontendProjects} showPopupFlag={false} />

            <h2 className="heading">Open-Source Contribution</h2>
            <div className="github-con">
                <a href="https://github-readme-stats.vercel.app/api?username=Darshan-SD&theme=holi" className="github-link">
                    <img
                        src="https://github-readme-stats.vercel.app/api?username=Darshan-SD&theme=holi&show_icons=true&rank_icon=github&custom_title=Github Stats"
                        alt="@Darshan's Holopin board"
                    />
                </a>
            </div>

            <h2 className="heading">Holopin Badges</h2>
            <div className="holopin-con">
                <p className="holopin-desc">Every year, DigitalOcean hosts Hacktoberfest to support open-source projects. These are the badges I earned while contributing.</p>
                <a href="https://holopin.io/@darshansd" className="holopin-link">
                    <img
                        src="https://holopin.me/darshansd"
                        alt="@Darshan's Holopin board"
                    />
                </a>
            </div>
        </motion.div>
    )
}

export default Projects;